import React from "react";
import Card from "../Card";
import SectionHeader from "../SectionHeader";
import { IconUsers, IconAward, IconForum } from "../brand/icons";

const benefits = [
  {
    icon: IconUsers,
    title: "Build lasting connections with families who need your expertise",
    text: "Connect directly with parents, neurodivergent teens, and adults looking for empathetic, neuro-affirming guidance tailored to their reality.",
  },
  {
    icon: IconAward,
    title: "Gain visibility in a trusted community",
    text: "Elevate your practice without clinical bureaucracy. Showcase your credentials, lived insights, and neuro-affirming service models to an engaged audience.",
  },
  {
    icon: IconForum,
    title: "Access tools and forums to expand your impact.",
    text: "Use dedicated community threads, direct parent messaging, and neurodivergent-friendly interactive resources to facilitate continuous growth.",
  },
];

const AllyBenefits = () => {
  return (
    <section className="w-full py-16 md:py-20 bg-mist-soft text-left">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <SectionHeader
          title="Ally Benefits"
          light="What's in it"
          bold="for you?"
          para="Meaningful connection, professional trust, and purposeful collaboration."
          className="mb-10 md:mb-12"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-stretch">
          {benefits.map(({ icon: Icon, title, text }) => (
            <Card
              key={title}
              variant="white"
              className="!p-7 md:!p-8 border-hairline shadow-comfort flex flex-col"
            >
              <div className="w-14 h-14 rounded-brand bg-cloud-mist text-spectrum-blue flex items-center justify-center mb-6 shrink-0">
                <Icon size={28} />
              </div>
              <h3 className="font-headline text-headline-sm text-spectrum-blue leading-snug mb-3">
                {title}
              </h3>
              <p className="font-body text-body-md text-muted leading-relaxed mt-auto">
                {text}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AllyBenefits;
